/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountContact,
  AccountEmailPeriod,
  CreateAccountContactRequest,
  UpdateAccountContact,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Get an account's active contacts, keyed on the Junifer contact id
 */
export const getAccountContacts = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<AccountContact[]>>,
) => {
  return backofficeRequest<AccountContact[]>(
    { url: `/accounts/${billingAccountId}/contacts`, method: "GET" },
    options,
  )
}
/**
 * @summary Create a contact for an account
 */
export const createAccountContact = (
  billingAccountId: number,
  createAccountContactRequest: CreateAccountContactRequest,
  options?: SecondParameter<typeof backofficeRequest<AccountContact>>,
) => {
  return backofficeRequest<AccountContact>(
    {
      url: `/accounts/${billingAccountId}/contacts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAccountContactRequest,
    },
    options,
  )
}
/**
 * Read from our copy of Junifer's contact versions, so it covers changes made before this endpoint existed. Cancelled and deleted contact links are left out. An address that came back later has one entry per period.
 * @summary Get every email address the account has had, each with the period it was in use
 */
export const getAccountEmailHistory = (
  billingAccountId: number,
  options?: SecondParameter<typeof backofficeRequest<AccountEmailPeriod[]>>,
) => {
  return backofficeRequest<AccountEmailPeriod[]>(
    {
      url: `/accounts/${billingAccountId}/contacts/email-history`,
      method: "GET",
    },
    options,
  )
}
/**
 * @summary Update a contact for an account
 */
export const updateAccountContact = (
  billingAccountId: number,
  juniferContactId: number,
  updateAccountContactBody: UpdateAccountContact,
  options?: SecondParameter<typeof backofficeRequest<void>>,
) => {
  return backofficeRequest<void>(
    {
      url: `/accounts/${billingAccountId}/contacts/${juniferContactId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateAccountContactBody,
    },
    options,
  )
}
export type GetAccountContactsResult = NonNullable<
  Awaited<ReturnType<typeof getAccountContacts>>
>
export type CreateAccountContactResult = NonNullable<
  Awaited<ReturnType<typeof createAccountContact>>
>
export type GetAccountEmailHistoryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountEmailHistory>>
>
export type UpdateAccountContactResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountContact>>
>
